import 'venuescanner-scss/stylesheets/components/VenueDiscovery.Horizontal.scss'
import ScrollMagic from 'scrollmagic'
import { $, pageLoaded } from 'venuescanner-js/tools/elemental'

pageLoaded(() => {
  // scrollmagic
  let controller = new ScrollMagic.Controller();

  new ScrollMagic.Scene({
    triggerElement: '#venueDiscoveryHorizontal',
    triggerHook: 0.5,
    offset: -300,
    reverse: false
  })
    .setClassToggle('#venueDiscoveryHorizontal, .venue-discovery-horizontal__filter:first-child', 'active')
    .on('enter', function () {
      setTimeout(function () {
        $('.venue-discovery-horizontal__title__underline').css({
          left: $('.venue-discovery-horizontal__filter.active').offset() .left + ($('.venue-discovery-horizontal__filter.active').width() / 2) + 'px',
          opacity: 1
        })
        $('.venue-discovery-horizontal__block.active.hide-initial').removeClass('hide-initial')
      }, 500)
    }
    )
    .addTo(controller)

  function setActiveUnderlinePosition () {
    setTimeout(function () {
      $('.venue-discovery-horizontal__title__underline').css({ left: $('.venue-discovery-horizontal__filter.active').offset() .left + ($('.venue-discovery-horizontal__filter.active').width() / 2) + 'px' })
    }, 0);
  }

  $('.venue-discovery-horizontal__filter').click(function () {
    $('.venue-discovery-horizontal__filter.active').removeClass('active')
    $('.venue-discovery-horizontal__block.active').removeClass('active')
    $(this).addClass('active')
    $('.venue-discovery-horizontal__block--' + $(this).attr('data-filter-type')).addClass('active')
    setActiveUnderlinePosition(this)
  })
})
